import React, { useState } from 'react'
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Loader from '../../Alert/Loader';

const Studentcard = () => {
  const { studentAuth } = useSelector((state) => state.student);
  const { profile } = studentAuth;
  const [loading,setLoading]=useState(true)
  // This component reads the logged-in STUDENT's profile. It is also mounted
  // at /center/md-id, where no student is logged in, so profile is empty and
  // profile.id used to throw and blank the whole page. Render a message
  // instead of an ID card that cannot be built.
  if (!profile?.id) {
    return (
      <div class="Title-box">
        <div class="row">
          <div class="">
            <div class="BigTitle">Student ICard</div>
            <p className="mt-3">No student ID card is available for this login.</p>
          </div>
        </div>
      </div>
    );
  }
  return (
     <div class="Title-box">
      <div class="row">
        <div class="">
          <div class="BigTitle">Student ICard</div>
          {loading ?<div className="text-center mt-5" >
              <Spinner animation="border" role="status" size="lg" style={{height:"6rem",width:"6rem"}}>
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div> : null}
           <iframe
                    src={`https://nsvec.com/api/public/download/student/card/${profile.id}`}
                     onLoad={()=>setLoading(false)}
                    width={"100%"}
                    height={"100%"}
                  ></iframe>
          </div>
          </div>
          </div>
  )
}

export default Studentcard